import {
	Popover,
	PopoverTrigger,
	PopoverContent,
	PopoverBody,
	PopoverArrow,
	IconButton,
	Button,
	Stack,
	Flex
} from '@chakra-ui/react';

import { BsThreeDotsVertical } from 'react-icons/bs';
import { BiEdit, BiWindowOpen } from 'react-icons/bi';
import { TfiViewGrid } from 'react-icons/tfi';
import useAuth from '../../hooks/useAuth';

type ButtonOptionsProps = {
	onOpen?: () => void;
	onView?: () => void;
	onEdit: () => void;
	openHomeworks?:() => void;
	isBook:boolean;
};
export default function ButtonOptions({ onView, onEdit, onOpen, isBook, openHomeworks }: ButtonOptionsProps) {
	const {user} = useAuth();

	const mostrarVisualizar = !isBook && !!onView;
	const mostrarHomeworks = !isBook && !!openHomeworks;
	const mostrarAbrir = isBook && !!onOpen;
	const mostrarEditar = user?.userType === 'ADMIN';

	// Sem nenhuma acao o popover abriria vazio, entao o proprio botao some.
	// E o caso do professor na pagina de books, onde o card ja abre as lessons no clique.
	if (!mostrarVisualizar && !mostrarHomeworks && !mostrarAbrir && !mostrarEditar) return null;

	return (
		<Flex justifyContent="center">
			<Popover placement="bottom" isLazy>
				<PopoverTrigger>
					<IconButton
						aria-label="More server options"
						icon={<BsThreeDotsVertical />}
						variant="solid"
						rounded="md"
						colorScheme="blue.800"
						_hover={{
							bgColor: 'blue.600',
							cursor: 'pointer'
						}}
					/>
				</PopoverTrigger>
				<PopoverContent w="fit-content" _focus={{ boxShadow: 'none' }}>
					<PopoverArrow />
					<PopoverBody>
						<Stack>
							{
								mostrarVisualizar &&
									<Button
										w="120px"
										variant="ghost"
										rightIcon={<TfiViewGrid />}
										justifyContent="space-between"
										fontWeight="normal"
										fontSize="sm"
										onClick={onView}
									>
										Visualizar
									</Button>
							}
							{
								mostrarHomeworks &&
									<Button
										w="120px"
										variant="ghost"
										rightIcon={<BiWindowOpen />}
										justifyContent="space-between"
										fontWeight="normal"
										fontSize="sm"
										onClick={openHomeworks}
									>
										Homeworks
									</Button>
							}
							{ mostrarAbrir && <Button
								w="120px"
								variant="ghost"
								rightIcon={<BiWindowOpen />}
								justifyContent="space-between"
								fontWeight="normal"
								fontSize="sm"
								onClick={onOpen}
							>
								Abrir
							</Button>}
							{
								mostrarEditar &&
									<Button
										w="120px"
										variant="ghost"
										rightIcon={<BiEdit />}
										justifyContent="space-between"
										fontWeight="normal"
										fontSize="sm"
										onClick={onEdit}
									>
										Editar
									</Button>
							}

						</Stack>
					</PopoverBody>
				</PopoverContent>
			</Popover>
		</Flex>
	);
}
